module.exports = __webpack_public_path__ + "img/subBanner9.5cac4350.png";